<template>
  <div class="flex h-full">
    <h4 class="mr-8 flex items-center justify-center uppercase font-semibold">
      Nóminas
    </h4>
    <router-link
      v-for="(menu, k) in options"
      v-bind:key="k"
      tag="span"
      :to="menu.path"
      class="
        cursor-pointer
        h-full
        p-2
        mx-2
        flex
        items-center
        justify-center
        -mb-2
      "
      exact-active-class="active"
      @click.native="$emit('clicked')"
    >
      <i :class="`el-icon-fa-${menu.icon} mr-2`"></i>
      {{ menu.name }}
    </router-link>
  </div>
</template>

<script>
import { checkPermissions } from "../../utils";

export default {
  name: "AccessSubMenu",
  data() {
    return {
      accessMenu: [
        {
          icon: "list-ul",
          path: "/paysheet/all",
          name: "Nóminas",
          submodule: "Todas",
        },
        // {
        //   icon: "exclamation-triangle",
        //   path: "/paysheet/active",
        //   name: "Acciones de personal"
        // },
        {
          icon: "clock-o",
          path: "/paysheet/overtime",
          name: "Aplicar horas extra",
          submodule: "HorasExtra",
        },
        // {
        //   icon: "bolt",
        //   path: "/paysheet/actions",
        //   name: "Acciones de personal"
        // },
        {
          icon: "list-ol",
          path: "/paysheet/historic",
          name: "Nóminas pasadas",
          submodule: "Historica",
        },
      ],
    };
  },
  computed: {
    options() {
      return this.accessMenu.filter(
        (item) =>
          this.$store.getters.isSuper ||
          checkPermissions(`Nomina:${item.submodule}`, "Page:view") ||
          checkPermissions(`Nomina:${item.submodule}`, "Page:viewOwn")
      );
    },
  },
};
</script>
